import { useState } from "react";
import { toast } from "sonner";
import { Input } from "../../components/ui/input";
import { api, errorMessage } from "../../lib/api";
import { useLang } from "../../lib/i18n";

const labelCls = "text-[11px] font-bold uppercase tracking-wider text-slate-500";

export const ResendSettings = ({ settings, onSaved }) => {
  const { t } = useLang();
  const on = settings.provider === "resend";
  const [key, setKey] = useState("");
  const [sender, setSender] = useState(settings.sender_email || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/admin/settings/email/resend", { api_key: key, sender_email: sender });
      onSaved(data);
      setKey("");
      toast.success(t("Resend connected"));
    } catch (e) { toast.error(errorMessage(e)); } finally { setSaving(false); }
  };
  const remove = async () => {
    if (!window.confirm(t("Disconnect Resend and go back to the built-in email service?"))) return;
    try { const { data } = await api.delete("/admin/settings/email/resend"); onSaved(data); setSender(""); toast.success(t("Resend disconnected")); }
    catch (e) { toast.error(errorMessage(e)); }
  };

  return (
    <div className="space-y-3 border-t border-slate-100 pt-3" data-testid="resend-settings">
      <div className="flex flex-wrap items-center gap-2">
        <p className="me-auto text-sm font-semibold text-slate-900">{t("Email provider")}</p>
        <span className={`rounded-full px-2.5 py-1 text-xs font-bold ${on ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`} data-testid="email-provider-status">
          {on ? t("Your Resend account") : t("Built-in email service")}
        </span>
      </div>
      <div className="grid gap-3 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
        <div className="space-y-1">
          <label className={labelCls} htmlFor="resend-key">{t("Resend API key")}</label>
          <Input id="resend-key" type="password" dir="ltr" autoComplete="off" value={key} onChange={(e) => setKey(e.target.value)}
            placeholder={settings.resend_key_masked || "re_..."} className="h-10 rounded-xl font-mono text-sm" data-testid="resend-key-input" />
        </div>
        <div className="space-y-1">
          <label className={labelCls} htmlFor="resend-sender">{t("Sender address")}</label>
          <Input id="resend-sender" type="email" dir="ltr" value={sender} onChange={(e) => setSender(e.target.value)}
            placeholder="noreply@inception.sa" className="h-10 rounded-xl" data-testid="resend-sender-input" />
        </div>
        <div className="flex gap-2">
          <button type="button" onClick={save} disabled={saving || !sender || (!on && !key)} data-testid="resend-save-button"
            className="btn-press min-h-[40px] rounded-xl bg-slate-900 px-4 text-sm font-semibold text-white disabled:opacity-50">
            {saving ? t("Saving…") : on ? t("Update") : t("Connect")}
          </button>
          {on && <button type="button" onClick={remove} data-testid="resend-remove-button"
            className="btn-press min-h-[40px] rounded-xl px-3 text-sm font-semibold text-slate-500 hover:text-wade">{t("Disconnect")}</button>}
        </div>
      </div>
      <p className="text-xs text-slate-400">{t("Optional. In Resend, verify your domain (e.g. inception.sa) and create an API key. The key is stored encrypted and never shown again. Use \"Send test\" on any notification to check it.")}</p>
    </div>
  );
};
